const conditionalAddress = (state) => {
  if (["vic", "wa", "tas", "sa"].includes(state)) {
    return "melbourne@misura.com.au";
    // return 'errol@tallied.com'
  } else if (["nsw", "act", "qld", "nt"].includes(state)) {
    return "sydney@misura.com.au";
    // return 'errol@tallied.com'
  } else {
    return "info@misura.com.au";
    // return 'errol@tallied.com'
  }
};

export default conditionalAddress;
